import { Text } from '@perch-labs/shrike';
import styled from 'styled-components';

// Mirrors Shrike's internal Modal.Header layout (StyledHeader/Title) so we can
// slot in a Download button next to the close button, which Modal.Header doesn't support.
export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.background.tertiary};
  padding: 24px 32px;
`;

export const HeaderTitle = styled(Text)`
  flex-grow: 1;
  text-align: left;
`;
